import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import { branding } from '../config/branding';
import { PermissionsProvider } from './lib/PermissionsContext';
import { DialogProvider } from './lib/DialogContext';

// Suppress Wrangler's IndexedDB StorageType.persistent deprecation warning
// This is from Wrangler's dev server infrastructure, not our code
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  const originalWarn = console.warn;
  // eslint-disable-next-line no-console
  console.warn = (...args: unknown[]) => {
    if (args[0]?.toString?.().includes('StorageType.persistent')) {
      return;
    }
    originalWarn(...args);
  };
}

// Set document title from branding config
document.title = branding.appTitle;

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <PermissionsProvider>
          <DialogProvider>
            <App />
          </DialogProvider>
        </PermissionsProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
